import { useMemo } from 'react'
import type { IResult } from 'ua-parser-js'
import { isZebraDevice } from 'utils/helpers'

interface DeviceInfo {
    deviceType:
        | 'mobile'
        | 'tablet'
        | 'desktop'
        | 'smarttv'
        | 'wearable'
        | 'embedded'
        | 'unknown'
    osName: string
    browserName: string
    isAppleDevice: boolean
    isAndroidDevice: boolean
    isZebraDevice: boolean
}

export const useDeviceInfo = (userAgentResult: IResult): DeviceInfo => {
    return useMemo(() => {
        const deviceType =
            (userAgentResult.device.type as DeviceInfo['deviceType']) ||
            'desktop'
        const osName = (userAgentResult.os.name ?? '').toLowerCase()
        const browserName = userAgentResult.browser.name || 'Unknown'
        const win = typeof window !== 'undefined' ? window : undefined
        const isZebra = win ? isZebraDevice(win) : false

        return {
            deviceType,
            osName,
            browserName,
            isAppleDevice: /iOS|Mac OS/.test(osName),
            isAndroidDevice: osName.startsWith('android') && !isZebra,
            isZebraDevice: isZebra,
        }
    }, [userAgentResult])
}
